export default {
  signalling: {
    host: import.meta.env.VITE_SIGNALLING_HOST,
  },
  statistics: {
    host: import.meta.env.VITE_STATISTICS_HOST,
  },
  billing: {
    host: import.meta.env.VITE_BILLING_HOST,
  },
  ai: {
    host: import.meta.env.VITE_AI_HOST,
  },
  geoip: {
    host: 'https://geoip.trueengage.com/json/',
    ip_host: 'https://api.ipify.org',
  },
  interactionHub: {
    host: import.meta.env.VITE_INTERACTIONHUB_HOST,
  },
  analytics: {
    id: 'UA-60572083-2',
  },
}
